import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice";
// import { updateDataInDb } from "../../../../../helper";
import { updateDataInMongoDb } from "../../../../../services/mongod.data";

const AuthModal = ({ setOpen, authName, setAuthName }) => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [loading, setLoading] = useState(false);

  const AuthHandler = async () => {
    setLoading(true);
    // let api_url = `${user}/graph-integration/zoho`;
    await updateDataInMongoDb(user, "graph-integration", ["zoho"], {
      authName: authName,
    });
    setLoading(false);
    
    window.open(`
    https://accounts.zoho.com/oauth/v2/auth?response_type=code&client_id=1000.SBAXN2F09W0ORH7KO2JKBCVMVFYVQH&scope=ZohoCampaigns.contact.ALL,ZohoMail.accounts.ALL&redirect_uri=https://dashboard.causalfunnels.com/integration/zoho&prompt=consent&access_type=offline`);
    // window.open(`
    // https://accounts.zoho.com/oauth/v2/auth?response_type=code&client_id=1000.SBAXN2F09W0ORH7KO2JKBCVMVFYVQH&scope=ZohoCampaigns.contact.ALL,ZohoMail.accounts.ALL&redirect_uri=http://localhost:3000/integration/zoho&prompt=consent&access_type=offline`);
  };
  return (
    <div className="relative">
      <div className="bg-gray-800/30 text-black  w-[100%] min-h-[500px] p-5 absolute inset-0 z-10 ">
        <div className="flex items-center justify-center h-full">
          <div className="bg-white rounded-md p-3 basis-2/3 relative">
            <RxCross2
              className="absolute right-3 hover:cursor-pointer"
              onClick={() => setOpen(false)}
            />
            <h2 className="text-2xl font-semibold my-3 mb-4">
              Create a new authentication
            </h2>
            <div className="flex flex-col gap-1">
              <label className="text-semibold">Your authentication name</label>
              <input
                type="text"
                value={authName}
                className="rounded-md text-sm border-gray-200 text-gray-500"
                onChange={(e) => setAuthName(e.target.value)}
              />
            </div>

            <div className="mt-20 space-x-3 flex justify-end ">
              <button
                className="text-gray-800 rounded-md p-2 px-3 border hover:text-indigo-600 hover:shadow-lg"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button
                onClick={AuthHandler}
                className="text-white rounded-md bg-indigo-600 p-2 px-3 hover:bg-indigo-500"
              >
                {loading ? "Loading..." : "Create"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
